import { FC, useContext } from 'react';

import { ARCHETYPE_WITH_IMAGE, ARCHETYPE_WITHOUT_IMAGE } from '../../../../constants/constants';
import BusinessUnitParamsContext from '../../../../contexts/BusinessUnitParamsContext/businessUnitParamsContext';
import CardHirePlan from '../CardHirePlan';
import CardHirePlanWithImage from '../CardHirePlanWithImage';

type Props = {
  infoToContract: any;
  businessPlanName: string;
};
const CardHirePlanWithArcheType: FC<Props> = ({ infoToContract, businessPlanName }) => {
  const { portalArchetypeId } = useContext(BusinessUnitParamsContext);

  const getCardHireComponent = () => {
    switch (portalArchetypeId) {
      case ARCHETYPE_WITHOUT_IMAGE:
        return <CardHirePlan infoToContract={infoToContract} businessPlanName={businessPlanName} />;
      case ARCHETYPE_WITH_IMAGE:
        return (
          <CardHirePlanWithImage
            infoToContract={infoToContract}
            businessPlanName={businessPlanName}
          />
        );
      default:
        return <CardHirePlan infoToContract={infoToContract} businessPlanName={businessPlanName} />;
    }
  };

  return getCardHireComponent();
};

export default CardHirePlanWithArcheType;
